import React from 'react';
import './Button.css';

function Button({
  variant = 'primary',
  loading = false,
  disabled = false,
  className = '',
  children,
  ...props
}) {
  return (
    <button
      className={`cw-btn cw-btn--${variant}${className ? ` ${className}` : ''}`}
      disabled={disabled || loading}
      {...props}
    >
      {loading && <span className="cw-btn-spinner" aria-hidden="true" />}
      {loading ? 'Processando…' : children}
    </button>
  );
}

export default Button;
